$(() => {
  const getResult = queryHash =>
    new Promise(resolve =>
      $.get(`/job_csvs/${queryHash}`, function (res) {
        resolve(res);
      })
    );

  $('[data-job-csv-output]').on('click', function (event) {
    event.preventDefault();
    const button = this;
    button.disabled = true;
    const buttonOriginalLabel = button.value;
    button.value = '出力中...';
    $.ajax({
      url: '/job_csvs',
      method: 'POST',
      processData: false,
      contentType: false,
      data: (() => {
        const fd = new FormData($(this).closest('form')[0]);
        fd.append(
          $('meta[name=csrf-param]').prop('content'),
          $('meta[name=csrf-token]').prop('content')
        );
        return fd;
      })(),
      success: function (res) {
        const iid = setInterval(() => {
          getResult(res.query).then(result => {
            console.log(result?.status);
            if (result?.status === 'exists') {
              clearInterval(iid);
              const anchorTag = $(`<a href="/job_csvs/${res.query}">`);
              $('body').append(anchorTag);
              anchorTag[0].click();
              anchorTag.remove();
              button.disabled = false;
              button.value = buttonOriginalLabel;
            }
          });
        }, 2000);
      },
    });
  });
});
